import React, { useEffect, useState } from 'react';
import configData from "../appconfig/config.json";
import { Form } from '@progress/kendo-react-form';
import { Field } from '@progress/kendo-react-form';
import { FormCheckbox, FormReviewLabel } from '../core/customComponents';
import { termsValidator, tovalidateExpdate } from '../core/validationRules';
import FormContainer from './FormContainer';
import { Button } from '@progress/kendo-react-buttons';
import { Checkbox, TextArea } from "@progress/kendo-react-inputs";

import { useHistory } from "react-router-dom";
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";

import { v4 as uuidv4 } from 'uuid';
import useCountDown from "react-countdown-hook";
import {
    Notification,
    NotificationGroup,
} from "@progress/kendo-react-notification";
import toFetchIDValue from '../data/IdTypeCheck';

var CryptoJS = require("crypto-js");
let key = CryptoJS.enc.Utf8.parse("8080808080808080");
let iv = CryptoJS.enc.Utf8.parse("8080808080808080");


let LBL_TNC = configData.TERMS_CONDITIONS;
let LBL_SUBMITTED_TEXT = configData.LBL_SUBMITTED_TEXT;
configData.RefferenceNo = localStorage.getItem('Ref');
configData.CrediAbleAcntNo = localStorage.getItem('RefCA');

let url = configData.URL_TERMS;

let hideContentForSubmit = false;


let fullName = localStorage.getItem('Otp_Name');
let NRICVVal = localStorage.getItem('Otp_nric');
let mobileNo;
let creditAbleAcntNo;
let nominatedFullName;
let LoanAmoutSet;
let RepaymentPeriodset;
let nominatedBank;
let nominatedbankAcntNo;

let cmpnt = FormReviewLabel;

const ReviewDetails = (props) => {
    let history = useHistory();
    //TODO
    const [response, setResponce] = useState(null);
    const [OTPValue, setOTPValue] = useState("");
    const [OtpconfirmDisabled, setOtpconfirmDisabled] = useState(false);
    const [toshowResend, settoshowResend] = useState(false);
    const [isLoading, setIsLoading] = useState(false); //to show api call
    const [checkedTerms, setcheckedTerms] = useState(false); //to show api call
    const [disabltoRequestotp, setdisabltoRequestotp] = useState(true); //to show api call
    const [currentDateTime, setcurrentDateTime] = useState(); //to show api call


    const [count3TimeToExist, setcount3TimeToExist] = useState(0);
    const initialTime = 120 * 1000; // initial time in milliseconds, defaults to 60000
    const interval = 1000; // interval to change remaining time amount, defaults to 1000
    const [timeLeft, { start, pause, resume, reset }] = useCountDown(
        initialTime,
        interval
    );

    const [ALLOTPgenration, setALLOTPgenration] = useState("");

    const [SavedInformation, setSavedInformation] = useState({
        emailAddress: "",
        idNum: "",
        idType: "",
        idIssueCountry: "",
        emailAddress: "",
        customerName: "",
        by_prdType: "",
        uniqueRequestId: ""
    });


    const [trimMobile, settrimMobile] = useState("");
    let resMobile;
    let resCountrycode;

    const [tohideNotification, settohideNotification] = useState(false);
    const [OtpMobilenumberGen, setOtpMobilenumberGen] = useState("");


    const [toshowMobileNo, settoshowMobileNo] = useState(false);


    const [emailValue, setemailValue] = useState('');

    useEffect(() => {
        if (tovalidateExpdate(new Date().getMinutes())) {
            if (configData.RefferenceNo) {
                const requestBody = {
                    //new changes passing details to save at verification
                    referenceno: configData.RefferenceNo,
                    num: localStorage.getItem('nricval')
                }

                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Access-Control-Allow-Headers': 'Content-Type',
                        'Cache-Control': 'no-cache',//for IE issues
                        'Pragma': 'no-cache',
                        'Authorization': "Maybank" + " " + localStorage.getItem('tkn')

                    },
                    body: JSON.stringify(requestBody)

                };

                fetch(configData.GET_FTDATA, requestOptions)

                    .then(async response => {

                        const data = await response.json();
                        if (!data.didError) {

                            if (data.model.fields) {
                                if (data.model.fields.Fields) {
                                    configData.NEWReffID = data.refNo;
                                    setResponce(data.model.fields.Fields);
                                    setSavedInformation(data.model);
                                    window.scrollTo(0, 0);
                                }
                            }
                            //   console.log(response);
                        } else {

                        }
                    })
                    .catch(err => {
                        console.log(err)
                        alert("This session has timed out for your security.");
                        window.location.href = configData.URL_ToHomeScreen
                        localStorage.clear();
                        return false;

                    })

            }
            else {
                alert("This session has timed out for your security");
                document.location.href = configData.URL_ToHomeScreen;
                localStorage.clear();
                return false;
            }
        } else {
            alert("This session has timed out for your security. ");
            window.location.href = configData.URL_ToHomeScreen
            localStorage.clear();
            return false;
        }
    }, [])
    if (!response) {
        return false;
    } else {
        if (response.TL) {
            let res = response.TL;
            if (res.creditAbleAcntNo) {
                try {
                    configData.decryptCA = CryptoJS.AES.decrypt(res.creditAbleAcntNo, key, { iv: iv });
                    configData.decryptCA = configData.decryptCA.toString(CryptoJS.enc.Utf8);
                } catch (ex) {
                    console.log(ex);
                }
            }

            if (res.mobileNo) {
                try {
                    configData.decryptmbl = CryptoJS.AES.decrypt(res.mobileNo, key, { iv: iv });
                    configData.decryptmbl = configData.decryptmbl.toString(CryptoJS.enc.Utf8);
                } catch (ex) {
                    console.log(ex);
                }
            }

            fullName = res.fullName;
            NRICVVal = res.NRICVVal;
            mobileNo = res.mobileNo;
            creditAbleAcntNo = configData.decryptCA;
            nominatedFullName = res.nominatedFullName;
            nominatedBank = res.nominatedBank;
            nominatedbankAcntNo = res.nominatedbankAcntNo;
            LoanAmoutSet = res.loanAmount;
            RepaymentPeriodset = res.loanTenure;




        }
    }

    const toHHMMSS = (val) => {


        var sec_num = parseInt(val / 1000, 10); // don't forget the second param
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - hours * 3600) / 60);
        var seconds = sec_num - hours * 3600 - minutes * 60;

        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        return minutes + ":" + seconds;
    };

    const updateInputValue = async (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === "" || re.test(e.target.value)) {
            await setOTPValue(e.target.value);
        }

        if (OTPValue.length === 5) {
            await setOtpconfirmDisabled(true);
        } else {
            await setOtpconfirmDisabled(false);
        }
    };

    const isNumber = async (evt) => {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;

        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            await setOTPValue("");
            await setOtpconfirmDisabled(false);
            return false;
        } else {
            await setOtpconfirmDisabled(true);
            return true;
        }
    };


    const handleSubmit1 = () => {
        //OTP GENERATION START

        const responseOBJ = {};


        let requestBody = {
            idNum: SavedInformation.nric,//localStorage.getItem('Otp_nric'),
            idType: SavedInformation.idType,//localStorage.getItem('Otp_idtype'),
            idIssueCountryCode: SavedInformation.idIssueCountry,//localStorage.getItem('Otp_countCode'),
            email: SavedInformation.emailAddress,//localStorage.getItem('Otp_email'),
            name: SavedInformation.customerName,//localStorage.getItem('Otp_Name'),
            by_prdType: configData.PRODUCT_TYPE,
            uniqueRequestId: uuidv4(),//localStorage.getItem('Otp_StateIDvalue')// uuidv4()
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Cache-Control': 'no-cache',//for IE issues
                'Pragma': 'no-cache',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        };

        if (!requestBody.email) {
            requestBody.email = "";
        }

        fetch(configData.URL_SEND_OTP + requestBody.idNum + '/' + requestBody.idType + '/' + requestBody.idIssueCountryCode + '/' + uuidv4() + "?email=" + requestBody.email + "&name=" + requestBody.name + "&by_prodType=" + requestBody.by_prdType, requestOptions)
            .then(async response => {
                const data = await response.json();
                if (!data.didError) {
                    let res = data.model.msg;
                    let resMsgBdy = res.msgBody;
                    let resMsgHdr = res.msgHdr;
                    setALLOTPgenration(res.msgBody);

                    if (resMsgHdr.statusCode === "0") {
                        setdisabltoRequestotp(true);
                        settohideNotification(true);
                        settoshowResend(true);
                        start();
                        setIsLoading(false);
                        responseOBJ.refNo = data.refNo;

                        if (resMsgBdy.mobileNum) {
                            configData.decryptMbl = CryptoJS.AES.decrypt(resMsgBdy.mobileNum, key, { iv: iv })
                            configData.decryptMbl = configData.decryptMbl.toString(CryptoJS.enc.Utf8)
                            setOtpMobilenumberGen(configData.decryptMbl);
                            settoshowMobileNo(true);
                            let mobiltrim = (configData.decryptMbl).substring(6);
                            settrimMobile(mobiltrim)

                        } else {
                            configData.decryptMbl = resMsgBdy.mobileNum;
                            setOtpMobilenumberGen(configData.decryptMbl);
                            settoshowMobileNo(true);

                        }
                        setemailValue(localStorage.getItem('Otp_email'));



                    } else {
                        settoshowResend(false);
                        settoshowMobileNo(false);
                        setIsLoading(false);



                        history.push("error");
                        localStorage.clear();

                    }
                } else {
                    setIsLoading(false);
                    localStorage.clear();
                    setdisabltoRequestotp(false);
                    //history.push("error");
                    // this.props.history.push('error');
                }
            })
            .catch(error => {
                // this.setState({ errorMessage: error });
                if (configData.RESEND <= 1) {
                    //alert(error);
                }
                setIsLoading(false);
                setdisabltoRequestotp(false);
                console.error('There is an error!', error);

            });
        //OTP GENERATION END
    }



    const verifyOTPDetails = async () => {
        if (OTPValue) {
            if (!emailValue) {
                setemailValue('');
            }
            const requestBody = {
                //new changes passing details to save at verification
                idNum: SavedInformation.nric,
                idType: toFetchIDValue("IDTYPE", SavedInformation.idType),
                idIssueCountryCode: toFetchIDValue("countries", SavedInformation.idIssueCountry),
                email: SavedInformation.emailAddress,// emailValue,
                name: SavedInformation.customerName,//fullnameValue,
                by_prdType: configData.PRODUCT_TYPE,
                cifNum: ALLOTPgenration.cifNum,
                otp: OTPValue,
                mobileNum: "0",//req.mobileNum ? req.mobileNum.substring(3) : '',
                accessID: "00000000",//this.state.setAccessID,
                uniqueRequestid: uuidv4(),//req.uniqueID,
                appId: '0'//configData.AUTH_CODE_Encrypt
            }


            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Cache-Control': 'no-cache',//for IE issues
                    'Pragma': 'no-cache',
                },
                body: JSON.stringify(requestBody)

            };

            fetch(configData.URL_VERIFY_OTP, requestOptions)

                .then(async response => {

                    const data = await response.json();
                    if (!data.didError) {
                        let res = data.model.msg;
                        let resMsgBdy = res.msgBody;
                        let resMsgHdr = res.msgHdr;

                        if (data.token) {
                            let tokenid = data.token;
                            let expirytoken = data.tokenExpirationDate;





                            if (resMsgBdy) {
                                localStorage.setItem("nricval", resMsgBdy.nric);
                            }
                            if (resMsgHdr.statusCode === "0") {
                                //this.props.history.push('Fundtransfer');

                                settohideNotification(false);
                                // SubmitFormdetails();
                                SubmitFormdetailsSave();

                            }

                            else {
                                if (resMsgHdr.statusDesc)
                                    setcount3TimeToExist(count3TimeToExist + 1)
                                if (count3TimeToExist <= 1) {
                                    // await this.setState({ errorMessage: resMsgHdr.statusDesc });
                                    alert("The OTP entered has expired/is invalid. Please re-enter the 6 Digit OTP.")
                                    //alert("Please Enter the 6 Digit OTP sent to your mobile number registered with the bank.");
                                } else if (count3TimeToExist === 2) {
                                    alert("You have exceeded the max OTP to confirm, please try after some time");
                                    document.location.href = configData.URL_ToHomeScreen;
                                    window.localStorage.clear();
                                    window.sessionStorage.clear();
                                    return;
                                } else {
                                    alert("You have exceeded the max OTP to confirm, please try after some time");
                                    document.location.href = configData.URL_ToHomeScreen;
                                    localStorage.clear();
                                    return;
                                }

                            }
                        } else {
                            history.push("error");
                            //  this.props.history.push('error');
                            localStorage.clear();
                            //alert("Somthing went wrong, please try again");
                        }


                    } else {
                        history.push("error");
                        // this.props.history.push('error');
                        localStorage.clear();
                        // alert("Somthing went wrong, please try again");
                    }
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });

        } else {
            await setOtpconfirmDisabled(true);
            alert("Please enter valid numeric 6 digit OTP");
        }
    }


    const SubmitFormdetailsSave = async () => {

        const requestBody = {
            TL: {
                fullName: SavedInformation.customerName,//from personal info//to do change to gloabl
                NRICVVal: SavedInformation.nric,//from personal info//to do change to gloabl
                mobileNo: OtpMobilenumberGen,//from personal info//to do change to gloabl
                loanAmount: response.TL.loanAmount,
                loanTenure: response.TL.loanTenure,
                creditAbleAcntNo: creditAbleAcntNo,//11 digit Acnt No
                nominatedFullName: nominatedFullName,
                nominatedBank: nominatedBank,
                nominatedbankAcntNo: nominatedbankAcntNo,
                interestRate: response.TL.interestRate,
                effectiveIntRate: response.TL.effectiveIntRate,
                SOURCE_CODE: response.TL.SOURCE_CODE,//localStorage.getItem('Otp_Sc'),
                domain_URI: localStorage.getItem('domainURI')
            }
        }
        // console.log(requestBody)
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Cache-Control': 'no-cache',//for IE issues
                'Pragma': 'no-cache',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Authorization': "Maybank" + " " + localStorage.getItem('tkn')
            },
            body: JSON.stringify(requestBody)

        };

        fetch(configData.URL_SAVE_FT + "?refno=" + configData.RefferenceNo + "&prodtype=" + configData.PRODUCT_TYPE, requestOptions)
            .then(async response => {

                const data = await response.json();

                if (!data.didError) {
                    SubmitFormdetails();
                    window.scrollTo(0, 0);
                } else {
                    alert("Some thing went wrong! please try again")
                }



            })
            .catch(error => {
                alert("Some thing went wrong! please try again.");
                document.location.href = configData.URL_ToHomeScreen;

                console.error('There was an error!', error);


            });

    }

    const SubmitFormdetails = async () => {

        //TODO OTPCHANGES
        hideContentForSubmit = true
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Cache-Control': 'no-cache',//for IE issues
                'Pragma': 'no-cache',
                'Authorization': "Maybank" + " " + localStorage.getItem('tkn')
            }
        };

        fetch(configData.URL_SUBMIT + "?refno=" + configData.RefferenceNo + "&submit=true", requestOptions)
            .then(async response => {

                const data = await response.json();
                if (data.status === "Submitted") {
                    let datestr = new Date();
                    localStorage.setItem("ddt", datestr);
                    //let storedatestr = { hour: 'numeric', minutes: '2-digit' };
                    //setcurrentDateTime(datestr + " " + datestr.toLocaleString('en-us', storedatestr));
                    setcurrentDateTime(localStorage.getItem('ddt'));
                    hideContentForSubmit = true;
                    window.scrollTo(0, 0);
                    localStorage.clear();
                } else {
                    hideContentForSubmit = false;
                    console.log("error");
                }

            })
            .catch(error => {
                hideContentForSubmit = false;

                console.error('There was an error!', error);

            });

    }



















    const restart = () => {
        // you can start existing timer with an arbitrary value
        // if new value is not passed timer will start with initial value
        const newTime = 10 * 1000;
        start(newTime);
        settoshowResend(false);
        setOTPValue('');
        handleResendSubmit();
    }

    const handleResendSubmit = () => {
        handleSubmit1();
    };


    const termscheckoption = () => {
        setcheckedTerms(!checkedTerms);
        setdisabltoRequestotp(!disabltoRequestotp)

    }


    const toMaybankHome = () => {
        document.location.href = configData.URL_NAV_MAYBANK;
    }
    const toBackFTDetails = () => {
        history.push('loancalc');
    }

    return (
        <div className="container-fluid">

            <div className='row '>
                <div className="container mt-5">
                    <h2 className="welcome mb-0">{configData.APP_NAME}</h2>
                </div>

                <FormContainer>
                    <Form
                        // onSubmit={handleSubmit1}
                        render={(formRenderProps) => (
                            <form onSubmit={formRenderProps.onSubmit} className={'k-form'}>
                                <fieldset>
                                    <br></br>
                                    <div className="row around-xs inputPairelementVisible"  >
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            {!hideContentForSubmit && <legend>{configData.HDR_RVW_DETAILS}</legend>}
                                            {hideContentForSubmit && <legend>{configData.HDR_RVW_APPLICATION}</legend>}
                                        </div>
                                    </div>
                                    <hr className="panelLine"></hr>
                                </fieldset>

                                <fieldset>

                                    {!hideContentForSubmit && <div className="row around-xs inputPair elementVisible"  >
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{
                                            backgroundColor: "black", color: "white", padding: "20px", borderTopLeftRadius: "10px",
                                            borderTopRightRadius: "10px"
                                        }}>

                                            <strong className="text-left">{configData.LBL_FT_REQUEST}</strong>
                                            <strong className="text-right" style={{ float: 'right' }} onClick={toBackFTDetails}><span style={{ cursor: "pointer" }} className="k-icon k-i-pencil"></span></strong>


                                        </div>
                                    </div>}
                                    {hideContentForSubmit && <div className="row around-xs inputPair elementVisible"  >
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{
                                            backgroundColor: "#389a6e", color: "white", padding: "20px", borderTopLeftRadius: "10px",
                                            borderTopRightRadius: "10px"
                                        }}>

                                            <strong className="box text-left"><span className="k-icon k-i-check"></span><span style={{ padding: "8px" }}>Your application is submitted!</span></strong>

                                        </div>

                                    </div>}

                                </fieldset>
                                <fieldset>
                                    <Field id={"Full Name in NRIC/Passport"} label={SavedInformation.customerName} component={cmpnt} />
                                    <Field id={"NRIC/Passport No."} label={SavedInformation.nric} component={cmpnt} />
                                    {toshowMobileNo && <Field id={"Mobile Number"} label={OtpMobilenumberGen} component={cmpnt} />

                                    }



                                    <Field id={"Credit Card Account No."} label={creditAbleAcntNo} component={cmpnt} />

                                    <Field id={"Name as per your Nominated Bank Account"} label={nominatedFullName} component={cmpnt} />
                                    <Field id={"Nominated Bank"} label={nominatedBank} component={cmpnt} />
                                    <Field id={"Nominated Bank Account No"} label={nominatedbankAcntNo} component={cmpnt} />

                                    <Field id={"Loan Amount (S$)"} label={LoanAmoutSet} component={cmpnt} />

                                    <div class="row around-xs inputPair elementVisible" style={{
                                        fontSize: "12px"
                                    }}><div class=" col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box text-left"> - Processing Fee (if any) will be will be charged together with the first month's instalment payable by you.<br></br> - The Bank reserves the right to approve a loan amount lower than the requested loan amount specified, subject to 80% of your Credit Card available credit limit.</div></div></div>





                                    <Field id={"Repayment Period"} label={RepaymentPeriodset} component={cmpnt} />
                                    <br></br>
                                    <hr className="panelLine"></hr>
                                </fieldset>



                                <br></br><br></br>
                                <fieldset>
                                    {hideContentForSubmit &&

                                        <Field id={"Reference Number"} label={configData.NEWReffID} component={cmpnt} />

                                    }
                                    {hideContentForSubmit &&

                                        <Field id={"Date"} label={currentDateTime} component={cmpnt} />


                                    }
                                </fieldset>
                                
                                <div style={{textAlign: "justify"}}>
                                    <b><u>Fair Dealing</u></b> 
                                    <br></br><br></br>
                                    The Guidelines on Fair Dealing issued by the Monetary Authority of Singapore aim to promote fair dealing by financial institutions when they conduct business with their customers. At Maybank, we are fully committed to ensuring fair dealing outcomes for our customers. In providing products and services to our customers, there may be situations where we may have to exercise our right to unilaterally revise certain terms and conditions of such products or services. For more information, please refer to the Fair Dealing Disclosure Notice at maybank.sg/fairdealing.
                                </div>
                                <br></br>
                                
                                {!hideContentForSubmit &&



                                    <div>
                                        <Checkbox
                                            checked={checkedTerms}
                                            id={"declYesBOA"}
                                            disabled={checkedTerms}
                                            label={<div style={{
                                                marginTop: "-18px",
                                                marginLeft: "25px"
                                            }}>
                                                <span>I have read, understood and agreed to be bound by  </span>
                                                <a href={url} target="_blank">Terms and Conditions </a>
                                                <span> Governing Maybank FlexiCash (where applicable).</span>



                                            </div>}
                                            //validator={termsValidator}
                                            onChange={termscheckoption}
                                        />

                                        {
                                            checkedTerms === false &&
                                            <span style={{ color: "red", marginLeft: "10px" }}>{"Please accept terms & conditions of the application to proceed"}</span>
                                        }
                                    </div>
                                }

                                <br></br><br></br>
                                {hideContentForSubmit && <b>{LBL_SUBMITTED_TEXT}</b>}
                                <br></br><br></br>
                                {!hideContentForSubmit && <div className="text-right">
                                    {/* <button className="k-primary btnMaybank" type={'submit'} disabled={!formRenderProps.allowSubmit}  ><span>{configData.ON_CONFIRM}</span></button> */}

                                    <Button className="btn btn-success btnMaybank" type={'submit'} style={{ padding: "13px" }}
                                        primary={true}
                                        disabled={disabltoRequestotp} onClick={handleSubmit1}>{"CONFIRM/ REQUEST OTP"} </Button>

                                </div>
                                }
                                <br></br>
                                {hideContentForSubmit && <div className="text-center">
                                    <button className="btnMaybank" type={'submit'} onClick={toMaybankHome}><span>{configData.ON_DONE}</span></button>

                                </div>}
                                <br></br><br></br>
                            </form>

                        )} />


                    {tohideNotification ? (
                        <NotificationGroup
                            style={{
                                right: 0,
                                bottom: 0,
                                alignItems: "flex-start",
                                flexWrap: "wrap-reverse",
                            }}
                        >
                            <Notification
                                type={{ style: "warning", icon: false }}
                                closable={false}
                            >
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1">
                                        <div className="box"></div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                        <div
                                            className="box row"
                                            style={{
                                                textAlign: "left",
                                                color: "black",
                                                marginLeft: "10px",
                                            }}
                                        >
                                            <p> &nbsp; OTP will be sent to XXXX {trimMobile}</p>{" "}
                                            <p> &nbsp; Please confirm received OTP within 2 minutes. </p>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div
                                            className="box row"
                                            style={{
                                                textAlign: "left",
                                                color: "black",
                                                margin: "10px",
                                            }}
                                        >
                                            <div
                                                className="text-center"
                                                style={{ marginTop: "0.6rem" }}
                                            >
                                                <p
                                                    data-tip="If you did not receive any, you can requestanother SMS OTP in 2:00"
                                                    className=""
                                                >
                                                    {timeLeft === 0 && toshowResend ? (
                                                        <Button
                                                            className="btn btn-success btnMaybank"
                                                            style={{ padding: "6px", marginTop: "-4px" }}
                                                            primary={true}
                                                            onClick={restart}
                                                        // disabled={!OtpconfirmDisabled}
                                                        // onClick={handleResendSubmit}
                                                        >
                                                            RESEND OTP
                                                        </Button>
                                                    ) : (
                                                        <div></div>
                                                    )}


                                                    {toshowResend ? (
                                                        <div>
                                                            {" "}
                                                            Resend in {toHHMMSS(timeLeft)}{" "}
                                                            <span
                                                                className="k-icon k-i-clock"
                                                                style={{ marginTop: "-2px" }}
                                                            ></span>
                                                        </div>
                                                    ) : (
                                                        <div></div>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div className="box">
                                            <div
                                                className="text-center"
                                                style={{ marginTop: "1.2rem" }}
                                            >
                                                {/* <button type="button" className="k-button" onClick={formRenderProps.onFormReset}>Clear</button> &nbsp; */}
                                                <input
                                                    style={{ width: "100%" }}
                                                    onKeyPress={isNumber}
                                                    type="password"
                                                    pattern="[0-9]+"
                                                    maxLength="6"
                                                    minLength="6"
                                                    value={OTPValue}
                                                    onChange={updateInputValue}
                                                    placeholder="123456"
                                                    name=""
                                                    id="OTPValue"
                                                    className="k-textbox"
                                                ></input>
                                            </div>
                                        </div>
                                    </div>
                                    <br></br>
                                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div className="box">
                                            <div
                                                className="text-center"
                                                style={{ marginTop: "1rem" }}
                                            >


                                                {timeLeft === 0 ? (<Button
                                                    type={"submit"}
                                                    id="docSubmit"
                                                    key="docSubmit"
                                                    primary={true}
                                                    onClick={verifyOTPDetails}
                                                    style={{ padding: "6px" }}
                                                    className="btn btn-success btnMaybank "
                                                >
                                                    {"REQUEST"}
                                                </Button>) :

                                                    (<Button
                                                        className="btn btn-success btnMaybank"
                                                        style={{ padding: "6px" }}
                                                        primary={true}
                                                        onClick={verifyOTPDetails}
                                                        disabled={!OtpconfirmDisabled}
                                                    >
                                                        CONFIRM
                                                    </Button>)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1">
                                        <div className="box"></div>
                                    </div>
                                </div>
                            </Notification>
                        </NotificationGroup>
                    ) : (
                        ""
                    )}
                </FormContainer>

            </div>
        </div>
    )
}

export default ReviewDetails;